import Box from "@mui/material/Box";
import React from "react";

const ListHeader = ({ text }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 1,
        }}
      >
        <span
          style={{
            fontWeight: 700,
            fontSize: "1.5rem",
            color: "#8B1A1A",
            letterSpacing: 1,
          }}
        >
          {text}
        </span>
      </Box>
      <Box
        sx={{
          borderBottom: "2px solid rgba(139,26,26,0.2)",
          width: "100%",
          mb: 2,
        }}
      />
    </Box>
  );
};

export default ListHeader;
